module.exports = __webpack_public_path__ + "img/bg.0e320232.jpg";